import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';
import RoutesApp from '../../routes';

//Servicios
import { ViniedoService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import ViniedoSearch from './ViniedoSearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';

function ViniedoSearchContainer() {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.ViniedoPage, [state.ViniedoPage]);

    const [loader, setLoader] = useState(false);
    let apiTablePages;

    useEffect(() => {
        //Obtenemos la cantidad total de registros de viñedos que buscamos para generar el número maximo de paginas de la tabla
        const getViniedoSearchCuantity = async () => {
            try {
                setLoader(true);

                const ViniedoSearchCuantity = await ViniedoService.totalRecords(
                    {
                        ...SearchParameters.viniedos,
                    }
                );

                if (ViniedoSearchCuantity)
                    apiTablePages = ViniedoSearchCuantity.data;

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        //Obtenemos los registros de viñedos que buscamos para crear la tabla resultante
        const getViniedoSearch = async () => {
            try {
                setLoader(true);

                const ViniedoSearch = await ViniedoService.search({
                    ...SearchParameters.viniedos,
                    pagina: tablePage,
                });

                if (ViniedoSearch) {
                    setTableData(
                        buildTableData(ViniedoSearch.data, apiTablePages)
                    );
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getViniedoSearchCuantity();
        getViniedoSearch();
    }, [tablePage, SearchParameters.viniedos]);

    /**Función que crea la tabla resultante de la búsqueda de viñedos */
    const buildTableData = (data = [], tablePages = 1) => {
        return {
            title: 'Viñedos',
            headers: [
                'Viñedo',
                'Titulares',
                'Departamento',
                'Seccional',
                'Padrones',
                'Habilitado',
                ' ',
            ],
            pagination: 10,
            tablePages,
            pageType: 'ViniedoPage',
            data:
                data.length > 0
                    ? data?.map((v) => {
                          return {
                              viniedo: v.num,
                              titulares: v.titulares,
                              departamento: masters?.Departments.find(
                                  (d) => d.id === v.departamento
                              )?.nombre,
                              seccional: v.seccional,
                              padrones: v.padrones?.replaceAll(/[._-]/g, ' '),
                              habilitado: v.habilitado ? 'SI' : 'NO',
                              icons: (
                                  <div>
                                      <Link
                                          to={RoutesApp.Viniedos.single + v.id}
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <ViniedoSearch tableData={tableData} />;
}

export default ViniedoSearchContainer;
